import $http from "./http";
import config from "./config";
export default {
  name: "flight",
  getUrl(url) {
    return config.getUrl(this.name, url);
  },

  CheckRepeatOrder(data) {
    return $http.post(this.getUrl("/FlightOrder/CheckRepeatOrder"), data, {
      failTips: false,
    });
  },

  CreateOrder(data) {
    return $http.post(this.getUrl(`/FlightOrder/CreateOrderByProduct`), data);
  },
  OrderDetails(UniqueID) {
    return $http.get(this.getUrl(`/FlightOrder/OrderDetails?UniqueID=${UniqueID}`));
  },
  OrderSubmit(UniqueID) {
    return $http.get(this.getUrl(`/FlightOrder/OrderSubmit/${UniqueID}`));
  },
  // CreateReceiveRequest(data) {
  //     return $http.post(this.getUrl('/FlightOrder/CreateReceiveRequest'), data);
  // },
  // TradeSubmit(id) {
  //     return $http.get(this.getUrl(`/FlightOrder/SubmitReceiveRequest?TradeID=${id}`));
  // },
  OrderCannot(id) {
    return $http.get(this.getUrl(`/FlightOrder/OrderCannot?UniqueID=${id}`));
  },
  OrderDrawer(id) {
    return $http.get(this.getUrl(`/FlightOrder/OrderDrawer?UniqueID=${id}`));
  },
  OrderReject(id) {
    return $http.get(this.getUrl(`/FlightOrder/OrderReject?UniqueID=${id}`));
  },
  OrderResolve(data) {
    return $http.post(this.getUrl(`/FlightOrder/OrderResolve`), data);
  },
  UpdateGoods(goods) {
    return $http.post(this.getUrl("/FlightOrder/UpdateGoods"), goods);
  },
  CreateAmend(amend) {
    return $http.post(this.getUrl(`/FlightOrder/CreateAmend`), amend);
  },
  SubmitAmend(UniqueID) {
    return $http.get(this.getUrl(`/FlightOrder/SubmitAmend/${UniqueID}`));
  },
  AmendDetails(UniqueID) {
    return $http.get(this.getUrl(`/FlightOrder/AmendDetails?UniqueID=${UniqueID}`));
  },
  ClientOrderResolve(data) {
    return $http.post(this.getUrl("/FlightOrder/ClientOrderResolve"), data);
  },

  // OrderList(data) {
  //     return $http.post(this.getUrl('/FlightOrder/List'), data);
  // },
  // AmendList(data) {
  //     return $http.post(this.getUrl('/FlightAmend/List'), data);
  // },
  ReplenishOrderInfomation(data) {
    return $http.post(this.getUrl("/FlightOrder/ReplenishOrderInfomation"), data);
  },
  ConfirmClientAmendPrice(data) {
    return $http.post(this.getUrl("/FlightOrder/ConfirmClientAmendPrice"), data);
  },

  ConfirmSupplyAmendPrice(data) {
    return $http.post(this.getUrl("/FlightOrder/ConfirmSupplyAmendPrice"), data);
  },

  CreateRefundRequest(data) {
    return $http.post(this.getUrl("/FlightOrder/CreateRefundRequest"), data);
  },
  RefundJudge(UniqueID) {
    return $http.get(this.getUrl(`/FlightOrder/RefundJudge?UniqueID=${UniqueID}`));
  },
  UpdateOrder(data) {
    return $http.post(this.getUrl("/FlightOrder/UpdateOrder"), data);
  },
  // ChangeOrderDetail(data) {
  //     return $http.post(this.getUrl(`/FlightOrder/ChangeOrderDetail`), data)
  // },
  OrderCancel(id) {
    return $http.get(this.getUrl(`/FlightOrder/OrderCancel?UniqueID=${id}`), {
      failTips: false,
    });
  },

  CreateDemandOrder(id) {
    return $http.get(this.getUrl(`/FlightOrder/CreateSupplyDemandOrder?UnqiueId=${id}`));
  },

  OrderUnLock(id) {
    return $http.get(this.getUrl(`/FlightOrder/OrderUnLock?UniqueID=${id}`));
  },
  // UpdatePolicy(data) {
  //     return $http.post(this.getUrl('/FlightOrder/UpdatePolicy'), data);
  // },
  CreateB2GOrder(id) {
    return $http.get(this.getUrl(`/FlightOrder/CreateB2GOrder?UniqueID=${id}`));
  },
  CreateSupplyOrder(data) {
    return $http.post(this.getUrl("/FlightOrder/CreateSupplyOrder"), data);
  },
  SearchSupply(id, data) {
    return $http.post(this.getUrl("/FlightOrder/SearchSupply?channelCode=" + id), data);
  },
  OrderLock(id) {
    return $http.get(this.getUrl(`/FlightOrder/OrderLock?UniqueID=${id}`));
  },
  OrderRefund(data) {
    return $http.post(this.getUrl("/FlightOrder/OrderRefund"), data);
  },
  MessageSend(data) {
    return $http.post(this.getUrl("/FlightOrder/MessageSend"), data);
  },
  OrderRefundCancel(id) {
    return $http.get(this.getUrl(`/FlightOrder/OrderRefundCancel?UniqueID=${id}`));
  },
  ConfirmOrderPrice(data) {
    return $http.post(this.getUrl(`/FlightOrder/ConfirmOrderPrice`), data);
  },
  UpdateOrderStatus(id) {
    return $http.get(this.getUrl(`/FlightOrder/UpdateOrderStatus?UniqueID=${id}`));
  },
  UpdateOrderPrice(data) {
    return $http.post(this.getUrl("/FlightOrder/UpdateOrderPrice"), data);
  },
  AmendStatusBack(id) {
    return $http.get(this.getUrl(`/FlightOrder/AmendStatusBack?UniqueID=${id}`));
  },

  CreateTrade(data) {
    return $http.post(this.getUrl(`/FlightOrder/CreateTrade`), data);
  },

  // RangeQueries(data) {
  //     return $http.post(this.getUrl('/FlightOrder/RangeQueries'), data);
  // },
  // IConfirmOrder(data) {
  //     return $http.post(this.getUrl(`/FlightOrder/InternationalTicketOrder`), data);
  // },
  getOrderList(data) {
    return $http.post(this.getUrl("/FlightOrder/List"), data);
  },
  // FlightDatils(id) {
  //     return $http.get(this.getUrl(`/FlightOrder/FlightBDetails/${id}`));
  // },
  // IssueFlightTicket(data) {
  //     return $http.post(this.getUrl(`/FlightTicket/IssueFlightTicket`), data);
  // },
  // OverseasFlightTicket(data) {
  //     return $http.post(this.getUrl(`/FlightTicket/OverseasFlightTicket`), data);
  // },
  // FlightAudit(id) {
  //     return $http.get(this.getUrl(`/FlightOrder/FlightAudit/${id}`));
  // },
  // FlightAmend(data) {
  //     return $http.post(this.getUrl(`/FlightAmend/Added`), data);
  // },
  // AuditApproval(data) {
  //     return $http.post(this.getUrl(`/FlightAmend/AuditApproval`), data);
  // },
  FlightChange(data) {
    return $http.post(this.getUrl(`/FlightOrder/FlightOrderChange`), data);
  },
  // FlightUpdatePrice(data) {
  //     return $http.post(this.getUrl(`/FlightTicket/FlightUpdatePrice`), data);
  // },
  // OverseasChange(data) {
  //     return $http.post(this.getUrl(`/FlightConsumer/FlightChange`), data);
  // },
  // AmendList(data) {
  //     return $http.post(this.getUrl(`/FlightAmend/List`), data);
  // },
  // AmendDetails(id) {
  //     return $http.get(this.getUrl(`/FlightAmend/Details/${id}`));
  // },
  // FlightCNDetail(id) {
  //     return $http.get(this.getUrl(`/FlightOrder/FlightCNDetail/${id}`));
  // },
  // servicefee(data) {
  //     return $http.post(this.getUrl('/flightticket/SearchFee'), data)
  // },
  // searchAmendPrice(data) {
  //     return $http.post(this.getUrl('/flightorder/searchAmendPrice'), data);
  // },
  // AmendServiceFee(data) {
  //     return $http.post(this.getUrl('/flightticket/AmendServiceFee'), data);
  // },
  // submitsupply(id) {
  //     return $http.get(this.getUrl(`/flightamend/SubmitSupply/${id}`));
  // },
  // updateOrderStatus(data) {
  //     return $http.post(this.getUrl('/flightorder/UpdateOrderStatus'), data);
  // },
  updatepnr(data) {
    return $http.post(this.getUrl("/FlightOrder/updatepnr"), data);
  },
  // submitsupplyorder(id) {
  //     return $http.get(this.getUrl(`/flightorder/submitsupply/${id}`));
  // },
  //补退
  createamend(id) {
    return $http.get(this.getUrl(`/flightamend/createamend/${id}`));
  },
  updatepassinfo(data) {
    return $http.post(this.getUrl(`/FlightConsumer/updatepass`), data);
  },
  ConfirmPrice(data) {
    return $http.post(this.getUrl(`/FlightOrder/ConfirmPrice`), data);
  },

  CreateOrderByPreference(data) {
    return $http.post(this.getUrl("/FlightOrder/CreateOrderByPreference"), data);
  },
  SearchOrders(id) {
    return $http.get(this.getUrl(`/FlightOrder/SearchOrders?UniqueID=${id}`));
  },
  SupplyOrderPayment(id) {
    return $http.get(this.getUrl(`/FlightOrder/SupplyOrderPayment?UniqueId=${id}`));
  },
  flightchangeSave(data) {
    return $http.post(this.getUrl("/flightchange/save"), data);
  },
  getflightchanges(data) {
    return $http.post(this.getUrl("/flightchange/list"), data);
  },
  sendChangeMsg(data) {
    return $http.post(this.getUrl("/flightchange/SendMsg"), data);
  },
  getChangeMsg(data) {
    return $http.post(this.getUrl("/flightchange/GetChangeMsg"), data);
  },
  changeSolve(data) {
    return $http.post(this.getUrl(`/flightchange/solve`), data);
  },

  submitbychangereason(id) {
    return $http.get(this.getUrl("/flightorder/subamendorder?UniqueId=" + id));
  },
  searchndcamendprice(id) {
    return $http.get(this.getUrl("/FlightOrder/SearchAmendPriceAgain?UniqueID=" + id));
  },
  CreateAmendTradeDeal(id) {
    return $http.get(this.getUrl("/flightorder/CreateAmendTradeDeal?UniqueID=" + id));
  },
  PaymentSupplyOrder(id) {
    return $http.get(this.getUrl("/flightorder/PaymentSupplyOrder?UniqueId=" + id));
  },
  saveCompanyEmailConfig(data) {
    return $http.post(this.getUrl(`/flightorder/saveCompanyEmailConfig`), data);
  },
  deleteCompanyEmailConfig(id) {
    return $http.get(this.getUrl(`/flightorder/deleteCompanyEmailConfig?id=` + id));
  },
  companyEmailConfigList(data) {
    return $http.post(this.getUrl(`/flightorder/CompanyEmailConfigList`), data);
  },
  SubmitUmsChange(id) {
    return $http.get(this.getUrl("/flightorder/CreateSupplyChangeOrder?UniqueId=" + id));
  },
  SubmitUmsAmend(id) {
    return $http.get(this.getUrl("/flightorder/CreateSupplyAmendOrder?UniqueId=" + id));
  },
  SearchExtras(data) {
    return $http.post(this.getUrl("/FlightOrder/SearchExtras"), data);
  },
  CreateExtras(data) {
    return $http.post(this.getUrl("/FlightOrder/CreateExtras"), data);
  },
  SendEmail(orderId, unionId, email) {
    return $http.get(this.getUrl("/FlightOrder/SendEmail?orderId=" + orderId + "&UnionId=" + unionId + "&email=" + email));
  },
  getFlightOrderID(ClientUniqueID) {
    return $http.get(this.getUrl(`/flightorder/GetOrderIDByClientUniqueID?ClientUniqueID=${ClientUniqueID}`), { failTips: false });
  },
  SearchEsById(id, starttime, endtime) {
    return $http.get(this.getUrl(`/FlightOrder/SearchEsById?id=${id}&starttime=${starttime}&endtime=${endtime}`));
  },
  UpdateOrderClientUniqueId(data) {
    return $http.post(this.getUrl("/FlightOrder/UpdateOrderClientUniqueId"), data);
  },
  UpdateOrderSupplyStatus(UniqueID) {
    return $http.get(this.getUrl(`/flightorder/UpdateOrderSupplyStatus?UniqueID=${UniqueID}`));
  },
};



// WEBPACK FOOTER //
// ./src/apis/flightApis.js